// WACC 산출에 넘길 유사기업 결정 — 화면에 보이는 칩과 계산에 쓰인 종목이
// 어긋나면 안 되므로 규칙을 한 곳에 모으고 테스트로 고정한다.

export interface PeerPick {
  symbol: string;
  name: string;
}

export interface PeerInputPatch {
  peer_input_method: "direct" | "auto";
  peer_symbols?: string[];
  business_text?: string;
  peer_top_k?: number;
}

/**
 * @param method     화면에서 고른 선정 방식
 * @param picks      칩 목록 (직접 선정 + 자동 선정 결과를 편집한 것)
 * @param hasLookup  자동 선정을 한 번이라도 돌렸는가 (돌리기 전 칩은 직접 선정에서
 *                   넘어온 잔여물일 수 있어 자동 모드에서 쓰면 안 된다)
 */
export function resolvePeerInput(
  method: "direct" | "auto",
  picks: PeerPick[],
  hasLookup: boolean,
  bizText: string,
  topK: number,
): PeerInputPatch {
  if (method === "direct") {
    return { peer_input_method: "direct", peer_symbols: picks.map((x) => x.symbol) };
  }
  // 조회를 돌렸고 칩이 남아 있으면 그 칩이 곧 계산 대상이다 — 재선정을 건너뛰어
  // 타임아웃을 피하고, 사용자가 빼거나 더한 결과가 그대로 반영된다.
  if (hasLookup && picks.length) {
    return { peer_input_method: "direct", peer_symbols: picks.map((x) => x.symbol) };
  }
  // 칩을 모두 지웠거나 아직 조회 전 — 사업내용으로 새로 선정한다
  return { peer_input_method: "auto", business_text: bizText, peer_top_k: topK };
}
